import React, { useState } from 'react';
import { Container, Button, Modal, Popup, Form, Icon, Input, Grid, Segment } from 'semantic-ui-react'
import DataTable from 'react-data-table-component';
import { useSelector, useDispatch } from 'react-redux';
import {
   getEmployee,
   saveEmployee,
   updateEmployee,
   deleteEmployee,
   statusEmployee
} from '../Redux/Actions/EmployeeAction'
import { Formik } from 'formik'
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import DatePicker from "react-datepicker";
import moment from "moment";
import ConfirmModal from '../Components/ConfirmModal';
import TableLoader from '../Components/TableLoader';
import EmployeeExpandedComponent from "../Components/EmployeeExpandedComponent";
import { IMAGE_URL } from '../Resources/Api';
import noImage from '../Resources/images/no-image.jpg';

const Employee = () => {

   const inputRef = React.useRef();
   const dispatch = useDispatch()
   React.useEffect(() => {
      dispatch(getEmployee(toast, authToken))
      inputRef.current && inputRef.current.focus();
   }, [])

   const authToken = localStorage.getItem('accessToken');
   const [openModal, setOpenModal] = React.useState(false)
   const [openConfirm, setOpenConfirm] = React.useState(false)
   const [actionMode, setActionMode] = React.useState('');
   const [rowData, setRowData] = React.useState([]);
   const [searchInput, setSearchInput] = React.useState('');
   const loadingData = useSelector(state => state.loadingReducer.loadingPayload);
   const isPageLoading = loadingData && loadingData.string === 'list' ? loadingData.status : false

   const employeeData = useSelector(state => state.employeeReducer.employeePayload)
   const filteredItems = employeeData && employeeData.filter(item => (
      item.name.toLowerCase().includes(searchInput.toLowerCase())
   ));

   console.log(rowData && rowData.salary_rate && rowData.salary_rate.length > 0 && rowData.salary_rate[0].daily_rate);

   const searchComponent = <Input icon='search' placeholder='Search..' value={searchInput} onChange={e => setSearchInput(e.target.value)} />

   const actions = <React.Fragment>
      <Button
         primary
         onClick={() => (setOpenModal(true), setActionMode('Add'))}>
         <Icon name='add circle' />
         Add New
      </Button>
   </React.Fragment>;

   const conditionalRowStyles = [
      {
         when: row => row.status === 'I',
         style: {
            backgroundColor: '#f3f3f3',
            color: 'rgb(132 132 132 / 87%)'
         },
      }
   ]

   const columns = [
      {
         name: 'Employee Name',
         selector: 'name',
         sortable: true,
      },
      {
         name: 'Employee Id',
         selector: 'emp_id',
         sortable: true,
      },
      {
         name: 'Card No.',
         selector: 'card_no',
         sortable: true,
      },
      {
         name: 'Gender',
         selector: 'gender',
         sortable: true,
         cell: (data) => {
            if (data.gender === 'M') {
               return "Male"
            } else if (data.gender === "F") {
               return "Female"
            }
         }
      },
      {
         name: 'Daily Rate',
         cell: (data) => data && data.salary_rate.length > 0 ? data.salary_rate[0].daily_rate : '00',
         sortable: true,
      },
      {
         name: 'Hourly Rate',
         cell: (data) => data && data.salary_rate.length > 0 ? data.salary_rate[0].hourly_rate : '00',
         sortable: true,
      },
      {
         name: 'Image',
         selector: 'image',
         sortable: true,
         grow: 0,
         cell: (data) => <Popup
            style={{ padding: 5 }}
            content={<img
               height="150px"
               width="150px"
               alt={data.image ? data.image : "ImageName"}
               src={data.image ? IMAGE_URL + data.image : noImage} />}
            trigger={<img
               style={{ padding: 0 }}
               height="50px"
               width="50px"
               alt={data.image ? data.image : "ImageName"}
               src={data.image ? IMAGE_URL + data.image : noImage} />}
         />,
         width: '100px'
      },
      {
         name: 'Action',
         sortable: false,
         allowOverflow: true,
         button: true,
         width: '56px',
         right: true,
         cell: (data) =>
            <Popup
               style={{ padding: 0 }}
               position='left center'
               trigger={<Button color='basic' icon="ellipsis vertical" />}
               on='click'>
               <Button.Group vertical labeled icon color='basic' style={{ border: 0 }}>
                  <Button
                     icon='edit'
                     content='Edit'
                     onClick={() => (
                        setRowData(data),
                        setOpenModal(true),
                        setActionMode('Edit'))} />
                  <Button
                     icon='trash alternate outline'
                     content='Delete'
                     onClick={() => (
                        setOpenConfirm(true),
                        setRowData(data),
                        setActionMode('Delete'))} />
                  {data.status === 'I' ?
                     <Button icon='lock open' content='Active'
                        onClick={() => (
                           setOpenConfirm(true),
                           setRowData(data),
                           setActionMode('Active'))} /> :
                     <Button icon='lock' content='InActive'
                        onClick={() => (
                           setOpenConfirm(true),
                           setRowData(data),
                           setActionMode('InActive'))} />}
               </Button.Group>
            </Popup>
      },
   ];

   const customStyles = {
      header: {
         style: {
            minHeight: '40px',
         },
      },
      headRow: {
         style: {
            backgroundColor: 'rgb(33 133 208)',
            height: '10px',
            minHeight: '40px'
         },
      },
      table: {
         minHeight: '400px'
      },
      headCells: {
         style: {
            backgroundColor: 'rgb(33 133 208)',
            color: '#FFF',
            fontSize: '16px',
            fontWeight: '700',
         },
      }
   }

   const userSchema = Yup.object().shape({
      name: Yup.string()
         .min(2, 'Employee name is too short!')
         .max(50, 'Employee name is too Long!')
         .required('Employee name is required'),
      card_no: Yup.string()
         .required('Card no is required'),
      emp_id: Yup.string()
         .required('Employee id is required'),
      area: Yup.string()
         .required('Leaving area is required'),
      daily_rate: Yup.number()
         .required('Salary daily rate is required'),
   });

   return (
      <div>
         <Container fluid>
            <DataTable
               title='Employee Management'
               columns={columns}
               customStyles={customStyles}
               data={filteredItems}
               actions={actions}
               pagination={true}
               paginationResetDefaultPage={true}
               conditionalRowStyles={conditionalRowStyles}
               persistTableHead
               subHeader
               expandableRows
               expandableRowsComponent={<EmployeeExpandedComponent />}
               subHeaderComponent={searchComponent}
               progressPending={isPageLoading}
               progressComponent={<TableLoader />}
            />
            <Modal open={openModal} size='small'>
               <Formik
                  enableReinitialize
                  initialValues={{
                     id: actionMode === "Add" ? "" : rowData.id,
                     name: actionMode === "Add" ? "" : rowData.name,
                     father_name: actionMode === "Add" ? "" : rowData.father_name,
                     emp_id: actionMode === "Add" ? "" : rowData.emp_id,
                     card_no: actionMode === "Add" ? "" : rowData.card_no,
                     voter_id: actionMode === "Add" ? "" : rowData.voter_id,
                     aadhaar_id: actionMode === "Add" ? "" : rowData.aadhaar_id,
                     gender: actionMode === "Add" ? "" : rowData.gender,
                     dob: actionMode === "Add" ? new Date() : new Date(rowData.dob),
                     doj: actionMode === "Add" ? new Date() : new Date(rowData.doj),
                     address: actionMode === "Add" ? "" : rowData.address,
                     area: actionMode === "Add" ? "" : rowData.area,
                     daily_rate: actionMode === "Add" ? "" : rowData && rowData.salary_rate && rowData.salary_rate.length > 0 && rowData.salary_rate[0].daily_rate,
                     hourly_rate: actionMode === "Add" ? "" : "",
                     image: actionMode === "Add" ? "" : rowData.image
                  }}
                  validationSchema={userSchema}
                  onSubmit={(values, actions) => {
                     dispatch(saveEmployee(values, actions, setOpenModal, actionMode, toast, authToken))
                  }}>
                  {({
                     values,
                     errors,
                     touched,
                     handleChange,
                     handleBlur,
                     isSubmitting,
                     handleSubmit,
                     setFieldValue
                  }) => (
                     <React.Fragment>
                        <Modal.Header>{actionMode === "Edit" ? 'Update Post' : 'Create Post'}</Modal.Header>
                        <Modal.Content>
                           <Form id="myForm">
                              <Grid columns='equal'>
                                 <Grid.Column width={12}>
                                    <Form.Group widths='equal'>
                                       <Form.Input
                                          error={errors.name && touched.name ? { content: errors.name } : false}
                                          fluid
                                          label='Employee Name'
                                          placeholder='Employee Name'
                                          type="text"
                                          value={values.name}
                                          onChange={handleChange('name')}
                                       />
                                    </Form.Group>
                                    <Form.Group widths='equal'>
                                       <Form.Input
                                          error={errors.father_name && touched.father_name ? { content: errors.father_name } : false}
                                          fluid
                                          label='Father Name'
                                          placeholder='Father Name'
                                          type="text"
                                          value={values.father_name}
                                          onChange={handleChange('father_name')}
                                       />
                                    </Form.Group>
                                 </Grid.Column>
                                 <Grid.Column style={{ padding: 0 }}>
                                    <Segment style={{ padding: 0, width: '100%', height: '85%' }}>
                                       <label htmlFor="file-input" style={{ textAlign: 'center' }}>
                                          {values.image !== '' ?
                                             <div>
                                                <img
                                                   src={rowData && IMAGE_URL + rowData.image}
                                                   src={rowData && rowData.image ? IMAGE_URL + rowData.image : values.image}
                                                   style={{ width: 135, height: 150 }} />
                                             </div> :
                                             <div>
                                                <div style={{ display: 'flex', justifyContent: 'center' }}>
                                                   <Icon name="file image outline" size='huge' />
                                                </div>
                                                <h5>Upload Image</h5>
                                             </div>}
                                       </label>
                                       <input
                                          accept="image/*"
                                          id="file-input"
                                          type="file"
                                          style={{ display: 'none' }}
                                          onChange={(e) => setFieldValue('image', e.target.files[0])} />
                                    </Segment>
                                 </Grid.Column>
                              </Grid>
                              <Form.Group widths='equal'>
                                 <Form.Input
                                    error={errors.emp_id && touched.emp_id ? { content: errors.emp_id } : false}
                                    fluid
                                    label='Employee Id'
                                    placeholder='Employee Id'
                                    type="text"
                                    value={values.emp_id}
                                    onChange={handleChange('emp_id')}
                                 />
                                 <Form.Input
                                    error={errors.card_no && touched.card_no ? { content: errors.card_no } : false}
                                    fluid
                                    label='Card No'
                                    placeholder='Card No'
                                    type="text"
                                    value={values.card_no}
                                    onChange={handleChange('card_no')}
                                 />
                                 <Form.Input
                                    error={errors.voter_id && touched.voter_id ? { content: errors.voter_id } : false}
                                    fluid
                                    label='Voter Id'
                                    placeholder='Voter Id'
                                    type="text"
                                    value={values.voter_id}
                                    onChange={handleChange('voter_id')}
                                 />
                                 <Form.Input
                                    error={errors.aadhaar_id && touched.aadhaar_id ? { content: errors.aadhaar_id } : false}
                                    fluid
                                    label='Aadhaar Id'
                                    placeholder='Aadhaar Id'
                                    type="text"
                                    value={values.aadhaar_id}
                                    onChange={handleChange('aadhaar_id')}
                                 />
                              </Form.Group>
                              <Form.Group>
                                 <Form.Input
                                    width={10}
                                    error={errors.address && touched.address ? { content: errors.address } : false}
                                    fluid
                                    label='Address'
                                    placeholder='Address'
                                    type="text"
                                    value={values.address}
                                    onChange={handleChange('address')}
                                 />
                                 <Form.Input
                                    width={6}
                                    error={errors.area && touched.area ? { content: errors.area } : false}
                                    fluid
                                    label='Area'
                                    placeholder='Area'
                                    type="text"
                                    value={values.area}
                                    onChange={handleChange('area')}
                                 />
                              </Form.Group>
                              <Form.Group widths='equal'>
                                 <Form.Field>
                                    <label className="form-lable-top-small">Gender</label>
                                    <Form.Group widths='equal' inline style={{ marginTop: 10 }}>
                                       <Form.Radio
                                          label="Male"
                                          value="M"
                                          name="Gender"
                                          checked={values.gender === "M"}
                                          onChange={() => setFieldValue("gender", "M")}
                                       />
                                       <Form.Radio
                                          label="Female"
                                          value="F"
                                          name="gender"
                                          checked={values.gender === "F"}
                                          onChange={() => setFieldValue("gender", "F")}
                                       />
                                    </Form.Group>
                                 </Form.Field>
                                 <Form.Field>
                                    <label>Date of Birth</label>
                                    <DatePicker
                                       selected={values.dob}
                                       value={values.dob}
                                       onChange={(date) => setFieldValue("dob", date)}
                                       dateFormat="dd/MM/yyyy"
                                    />
                                 </Form.Field>
                                 <Form.Field>
                                    <label>Date of Joining</label>
                                    <DatePicker
                                       selected={values.doj}
                                       value={values.doj}
                                       onChange={(date) => setFieldValue("doj", date)}
                                       dateFormat="dd/MM/yyyy"
                                    />
                                 </Form.Field>
                                 <Form.Input
                                    error={errors.daily_rate && touched.daily_rate ? { content: errors.daily_rate } : false}
                                    fluid
                                    label='Daily rate'
                                    placeholder='Salary daily rate'
                                    type="number"
                                    value={values.daily_rate}
                                    onChange={handleChange('daily_rate')}
                                 />
                                 <Form.Input
                                    error={errors.hourly_rate && touched.hourly_rate ? { content: errors.hourly_rate } : false}
                                    fluid
                                    label='Hourly rate'
                                    placeholder='Salary hourly rate'
                                    type="text"
                                    readOnly
                                    value={values.daily_rate / 8}
                                    onChange={handleChange('hourly_rate')}
                                 />
                              </Form.Group>
                           </Form>
                        </Modal.Content>
                        <Modal.Actions>
                           <Button negative type="cancel" onClick={() => (dispatch(getEmployee(toast, authToken)), setOpenModal(false))}>
                              Close
                           </Button>
                           <Button
                              content={actionMode === "Edit" ? "Save" : "Create"}
                              type="submit"
                              labelPosition='right'
                              icon='checkmark'
                              loading={isSubmitting}
                              onClick={handleSubmit}
                              positive
                              form="myForm"
                              key="submit"
                              htmlType="submit"
                           />
                        </Modal.Actions>
                     </React.Fragment>
                  )}
               </Formik>
            </Modal>
            <Formik
               enableReinitialize
               initialValues={{
                  id: rowData.id,
                  status: actionMode === 'InActive' ? "I" : actionMode === 'Active' ? "A" : "D"
               }}
               onSubmit={(values, actions) => {
                  actionMode === 'Delete' ?
                     dispatch(deleteEmployee(values, actions, setOpenConfirm, toast, authToken)) :
                     dispatch(statusEmployee(values, actions, setOpenConfirm, toast, authToken))
               }}>
               {({
                  isSubmitting,
                  handleSubmit
               }) => (
                  <ConfirmModal
                     icon="trash alternate outline"
                     color="red"
                     open={openConfirm}
                     cancelText="Cancel"
                     comfirmText="Delete"
                     header={
                        actionMode === 'Delete' ? 'Delete Record' :
                           actionMode === 'InActive' ? 'Inactive Record' :
                              actionMode === 'Active' ? 'Active Rocord' : null
                     }
                     content={
                        actionMode === 'Delete' ? 'Data rocord will lost' :
                           actionMode === 'InActive' ? 'Data record will inactive.' :
                              actionMode === 'Active' ? 'Data record will active?' : null
                     }
                     onCancel={() => setOpenConfirm(false)}
                     onConfirm={handleSubmit}
                     loading={isSubmitting} />
               )}
            </Formik>
         </Container>
      </div>
   )
}

export default Employee